/**
 * Redux Store Configuration
 */

import { configureStore } from '@reduxjs/toolkit'
import { corporateApi } from '../services/corporate'

export const store = configureStore({
  reducer: {
    [corporateApi.reducerPath]: corporateApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(corporateApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

